module.exports = __webpack_public_path__ + "img/bf.5a14fa4c.svg";